import React from "react"
import PropTypes from "prop-types";
import Tr from "translations/Translations";
import Select from "components/Select";
import {makeStyles} from "@material-ui/core/styles";

const useStyle = makeStyles(theme => ({
    root: {
        width: 300
    }
}))

function OfferListInput(
    {
        id,
        formikProps,
        listValues,
        disabled
    }) {

    const classes = useStyle();

    return (
        <Select
            className={classes.root}
            id={id + ".value"}
            formikProps={formikProps}
            label={Tr('choose_value')}
            items={listValues}
            disabled={disabled}
        />
    )


}

OfferListInput.propTypes = {
    id: PropTypes.string.isRequired,
    listValues: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    disabled: PropTypes.bool.isRequired

}

export default OfferListInput;